import type {ColumnConfig} from 'schema/table/types';

export const publisherAgentDefaultColumns: ColumnConfig[] = [
  {
    name: 'nameVariants',
    visible: true,
    width: 200,
  },
  {
    name: 'isni',
    visible: true,
    width: 170,
  },
  {
    name: 'place',
  },
  {
    name: 'country',
  },
  {
    name: 'internalComments',
  },
  {
    name: 'externalComments',
  },
];
